import React from 'react';
import { LockIcon, MailIcon, ShieldCheckIcon, SmartphoneIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { BONUS_VALUE, CHECKOUT_URL, PRICE, PRODUCT } from '../data/content';
export function PricingSection() {
  return <section id="oferta" aria-labelledby="precios" className="bg-night" data-id="element-140" data-mp="1j9gyaqilbf9w">
      <div className="mx-auto max-w-page px-4 sm:px-6 lg:px-8 py-14 text-center" data-id="element-141" data-mp="1nb24xu4j6xbn">
        <Reveal data-id="element-142" data-mp="1s9n5junp3j0m">
          <p className="text-xs font-bold uppercase tracking-[0.3em] text-gold-bright" data-id="element-143" data-mp="1s93xr6rreb0b">
            Oferta especial de hoy
          </p>
          <h2 id="precios" className="mt-3 font-display text-3xl md:text-4xl font-bold uppercase text-white" data-id="element-144" data-mp="1x99ie2zm2x8w">
            {PRODUCT}
          </h2>
        </Reveal>

        <Reveal delay={0.05} className="mx-auto mt-8 max-w-2xl rounded-3xl border border-gold-bright/50 bg-white/5 p-7 md:p-10" data-id="element-145" data-mp="2w9zo0zxpmxe">
          <div className="grid gap-4 sm:grid-cols-2" data-id="element-146" data-mp="1mh6kz0e5945z">
            <div className="rounded-2xl bg-white/5 px-5 py-5" data-id="element-147" data-mp="1mirecmoq2h29">
              <p className="font-display text-2xl font-bold text-gold-light" data-id="element-148" data-mp="1howwlosogc5t">
                6
              </p>
              <p className="mt-1 text-sm font-semibold uppercase tracking-wide text-white/85" data-id="element-149" data-mp="1crem3tz0hovp">
                Módulos digitales
              </p>
            </div>
            <div className="rounded-2xl bg-white/5 px-5 py-5" data-id="element-150" data-mp="25g2avziyywe0">
              <p className="font-display text-2xl font-bold text-gold-light" data-id="element-151" data-mp="25d6eifmrsfro">
                5
              </p>
              <p className="mt-1 text-sm font-semibold uppercase tracking-wide text-white/85" data-id="element-152" data-mp="1vhcr217ij1v4">
                Bonos especiales
              </p>
            </div>
          </div>

          <p className="mt-6 text-sm font-semibold uppercase tracking-[0.14em] text-white/70" data-id="element-153" data-mp="1rhu7b8rfgwtv">
            Valor de los bonos{' '}
            <span className="line-through decoration-danger" data-id="element-154" data-mp="g0ukutrrhc7r">
              {BONUS_VALUE}
            </span>{' '}
            → hoy son gratis
          </p>

          <p className="mt-6 text-xs font-bold uppercase tracking-[0.28em] text-gold-bright" data-id="element-155" data-mp="hijbz8uhj2wj">
            Llevate todo por
          </p>
          <p className="mt-2 flex items-baseline justify-center gap-2" data-id="element-156" data-mp="7ju5ec81h4vl">
            <span className="font-display text-6xl md:text-7xl font-bold text-white" data-id="element-157" data-mp="7lok38spw0r8">
              {PRICE}
            </span>
            <span className="text-xl font-semibold text-white/70" data-id="element-158" data-mp="3uwxvtvzd7e69">ARS</span>
          </p>
          <p className="mt-1 text-xs font-bold uppercase tracking-[0.3em] text-gold-light" data-id="element-159" data-mp="3i09eh8sgp1r">
            Pago único
          </p>

          <p className="mx-auto mt-5 max-w-md text-sm leading-relaxed text-white/75" data-id="element-160" data-mp="3kz9qkc44uo9u">
            No pagás $19.990 + {BONUS_VALUE}.{' '}
            <span className="font-bold text-white" data-id="element-161" data-mp="3pxup873qkzw6">
              Pagás solo {PRICE} ARS
            </span>{' '}
            y recibís los 5 bonos sin costo adicional.
          </p>

          <div className="mt-7 flex justify-center" data-id="element-162" data-mp="3fy3xueah310b">
            <CtaButton href={CHECKOUT_URL} external size="lg" data-id="element-163" data-mp="2xatkz4bfi292">
              Quiero mi Mega Pack + 5 bonos gratis
            </CtaButton>
          </div>

          <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs text-white/75" data-id="element-164" data-mp="2sdl5xclkuec1">
            <li className="flex items-center gap-1.5" data-id="element-165" data-mp="369ouap9rrsgl">
              <LockIcon size={14} className="text-gold-bright" data-id="element-166" data-mp="31bnau38flr4l" />
              Pago seguro
            </li>
            <li className="flex items-center gap-1.5" data-id="element-167" data-mp="3g8xlxbh5wuzs">
              <MailIcon size={14} className="text-gold-bright" data-id="element-168" data-mp="3baw04iscqhkm" />
              Acceso digital inmediato
            </li>
            <li className="flex items-center gap-1.5" data-id="element-169" data-mp="3p2socbqwg7bq">
              <SmartphoneIcon size={14} className="text-gold-bright" data-id="element-170" data-mp="3p4diw1d7rq9l" />
              100% digital
            </li>
            <li className="flex items-center gap-1.5" data-id="element-171" data-mp="3l31u1y25z92g">
              <ShieldCheckIcon size={14} className="text-gold-bright" data-id="element-172" data-mp="2vuhjlf3bfx0" />
              Garantía de 7 días
            </li>
          </ul>
        </Reveal>
      </div>
    </section>;
}